import { createLitComponent } from "../lib/create-lit-component.js";
import { GivebutterGivingForm } from "@givebutter/widgets-core";
//#region src/components/GivebutterGivingForm.tsx
const GivebutterGivingForm$1 = createLitComponent({
	elementClass: GivebutterGivingForm,
	tagName: "givebutter-giving-form"
});
//#endregion
export { GivebutterGivingForm$1 as GivebutterGivingForm };
